<template>
  <div class="field-group">
    <label class="field-label"
      >Imagem (Opcional)
      <span
        class="help-icon"
        title="Selecione uma imagem opcional"
        >?</span
      ></label
    >
    <div class="file-upload">
      <label
        class="btn-escolher"
        @click="triggerFileInput"
        >Escolher arquivo</label
      >
      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        style="display: none"
        @change="handleFileChange"
      />
      <span class="file-name">{{
        nomeImagem || "Nenhum arquivo escolhido"
      }}</span>
    </div>
    <div
      v-if="imagemPreview"
      class="image-preview-container"
    >
      <img
        :src="imagemPreview"
        class="image-preview"
        alt="Preview da imagem"
      />
      <button
        class="btn-remover-imagem"
        @click.prevent="removerImagem"
      >
        Remover Imagem
      </button>
    </div>
    <div
      v-if="imagemSelecionada"
      class="field-group"
    >
      <label class="field-label required"
        >Descrição da Imagem
        <span
          class="help-icon"
          title="Informe uma breve descrição da imagem para acessibilidade"
          >?</span
        ></label
      >
      <input
        v-model="descricaoImagem"
        type="text"
        class="field-input"
        placeholder="Ex: Grupo de extensão em um evento"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useUploadImagem } from "@/composables/useUploadImagem";

const props = defineProps({
  imagem: {
    type: Object,
    default: null,
  },
});

const emits = defineEmits(["enviar-imagem"]);
const descricaoImagem = defineModel({ default: "" });
const fileInput = ref(null);

const {
  nomeImagem,
  preview: imagemPreview,
  imagemSelecionada,
  erro,
  processarArquivo,
  carregarPreview,
  limpar,
} = useUploadImagem();

function triggerFileInput() {
  fileInput.value.click();
}

async function handleFileChange(event) {
  const file = event.target.files[0];
  if (!file) return;
  const imagem = await processarArquivo(file);
  if (imagem) emits("enviar-imagem", imagem);
}

function removerImagem() {
  limpar();
  descricaoImagem.value = "";
  if (fileInput.value) {
    fileInput.value.value = "";
  }
  emits("enviar-imagem", null);
}

watch(
  () => [props.imagem?.base64Data, props.imagem?.mimeType, props.imagem?.url],
  ([base64, mime, url]) => {
    if (base64 && mime) {
      carregarPreview(mime, base64);
    } else if (url) {
      carregarPreview(url);
    } else if (
      typeof mime === "string" &&
      (mime.startsWith("http") || mime.startsWith("data:"))
    ) {
      carregarPreview(mime);
    }
  },
  { immediate: true }
);

onMounted(() => {
  if (props.imagem?.base64Data && props.imagem?.mimeType) {
    carregarPreview(props.imagem.mimeType, props.imagem.base64Data);
  } else if (props.imagem?.url) {
    carregarPreview(props.imagem.url);
  } else if (
    typeof props.imagem?.mimeType === "string" &&
    (props.imagem.mimeType.startsWith("http") ||
      props.imagem.mimeType.startsWith("data:"))
  ) {
    carregarPreview(props.imagem.mimeType);
  }
});
</script>

<style scoped>
.image-preview-container {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 10px;
  background-color: var(--branco);
  padding: 10px;
  border-radius: 8px;
  border: 1px dashed var(--cinza-claro);
}

.image-preview {
  width: 100px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid var(--cinza-claro);
}

.btn-remover-imagem {
  align-self: self-start;
  margin-left: auto;
  height: min-content;
  padding: 3px 6px;
  background-color: var(--vermelho-escuro);
  color: var(--branco);
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-remover-imagem:hover {
  background-color: var(--vermelho);
}
</style>
